module.exports = __webpack_public_path__ + "img/img_nice.adbde6e7.png";